import { createSelector } from "reselect";
import getRolesSelector from "./getRolesSelector";

export default createSelector([getRolesSelector], (roles: string[]) => roles.map(e => e.toLowerCase()).indexOf("administrator") > -1);
